import React from 'react'

const Download = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
      <path d="M3 8L7 12.232L11 8.041M7 1V12M1 15H13" stroke="#ffff" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export default Download